import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet, useLocation } from "react-router";
import ErrorBoundary from "../ErrorBoundary";
import Copyright from "../Copyright";
import Navbar from "../Navbar";
import { getTabName } from "../../routes";
const DEFAULT_DOCUMENT_TITLE = 'Veeva HCP Access';
const Layout = () => {
    const location = useLocation();
    const tabName = getTabName(location.pathname);
    if (tabName) {
        document.title = `${DEFAULT_DOCUMENT_TITLE} - ${tabName}`;
    }
    else {
        document.title = DEFAULT_DOCUMENT_TITLE;
    }
    return (_jsxs(ErrorBoundary, { children: [_jsx(Navbar, {}), _jsx(Outlet, {}), _jsx("footer", { children: _jsx(Copyright, {}) })] }));
};
export default Layout;
